import { supplierMap } from '@/api';
import { post } from '@/common/request';

export interface SupplierItem {
  id?: number;
  supplierName?: string;
  supplierType?: number;
  supplierTypeName?: string;
  brandName?: string;
  brandId?: number;
  remark?: string;
  createTime?: string;
}


export interface ContactItem {
  id?: number;
  supplierId?: number;
  contactName?: string;
  contactMobile?: string;
  wechatCode?: string;
  contactEmail?: string;
  sex?: number;
  enterpriseId?: number;
  departmentId?: number;
  positionId?: number;
  businessCard?: string;
  remark?: string;
}

export interface CollectionItem {
  id?: number,
  supplierId?: number,
  accountName?: number,
  accountNo?: number,
  bank?: string,
  payType?: string,
  payTypeName?: string,
  receiveType?: number,
  receiveTypeName?: string
}

export interface PointItem {
  id?: number;
  tenantSpotId?: number;
  supplierId?: number;
  referencePrice?: number;
  status?: number;
  statusName?: string;
  remark?: string;
  fileContent?: string;
  restoreDate?: string;
  restoreDateString?: string;
  reason?: string;
}

interface SupplyStatus {
  id?: number
  status?: number	 // 状态（1合作中，2暂停，3停止）
  restoreDate?: string	 // 恢复日期
  reason?: string	 // 原因(暂停原因、停止原因
}

type Status = 1 | 2 | 3

interface Response<T> {
  totalNum?: number;
  pageNum?: number;
  pageSize?: number;
  objectLIist: T[]
  meta?: any
}

class Supplier {
  getList(page: number, size: number, searchParams: SupplierItem): Promise<Response<SupplierItem>> {
    return post(supplierMap.get('list'), { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
  }

  getSupplierList(params: any): Promise<SupplierItem[]> {
    return post(supplierMap.get('supplierList'), params, { proxyApi: '/resserv', needHint: true });
  }

  getSelectList(params: any): Promise<SupplierItem[]> {
    return post(supplierMap.get('selectList'), params, { proxyApi: '/resserv', needHint: true });
  }

  deleteSupplier(id: number): Promise<boolean> {
    return post(supplierMap.get('delete'), { id }, { proxyApi: '/resserv', needHint: true });
  }

  getInfo(id: number): Promise<SupplierItem> {
    return post(supplierMap.get('detail'), { id }, { proxyApi: '/resserv', needHint: true });
  }

  getContactList(page: number, size: number, searchParams: ContactItem): Promise<Response<SupplierItem>> {
    return post(supplierMap.get('contactList'), { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
  }

  deleteContact(id: number): Promise<boolean> {
    return post(supplierMap.get('contactDelete'), { id }, { proxyApi: '/resserv', needHint: true });
  }

  getCollectionList(page: number, size: number, searchParams: ContactItem): Promise<Response<SupplierItem>> {
    return post(supplierMap.get('collectionList'), { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
  }

  getPointList(page: number, size: number, searchParams: PointItem): Promise<Response<PointItem>> {
    return post(supplierMap.get('pointList'), { page, size, ...searchParams }, { proxyApi: '/resserv', needHint: true });
  }

  deleteCollection(id: number): Promise<boolean> {
    return post(supplierMap.get('collectionDelete'), { id }, { proxyApi: '/resserv', needHint: true });
  }

  editStatus(id: number, status: Status, values: SupplyStatus): Promise<boolean> {
    return post(supplierMap.get('updateStatus'), { id, status, ...values }, { proxyApi: '/resserv', needHint: true });
  }
}

export default new Supplier();
